import clsx from 'clsx';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Card } from './Card';

export interface MetricTileProps {
    label: string;
    value: ReactNode;
    /** Caption under the value, e.g. "+6 vs. last Tuesday". No red/green arrows. */
    delta?: string;
    /** Chart under the value (block content such as a Sparkline). */
    trend?: ReactNode;
    /** Makes the whole tile a link. */
    to?: string;
    /** Orange surface and numeral: this number needs a person now. */
    attention?: boolean;
}

export const MetricTile = ({ label, value, delta, trend, to, attention }: MetricTileProps) => {
    const body = (
        <>
            <p className="text-small text-muted">{label}</p>
            <p className={clsx('mt-1 break-words font-display text-numeral tabular-nums', attention ? 'text-tone-warning-fg' : 'text-strong')}>
                {value}
            </p>
            {trend}
            {delta && <p className="mt-1 text-caption text-muted">{delta}</p>}
        </>
    );
    const tone = attention ? 'warning' : 'surface';
    return to ? (
        <Link to={to} className="block rounded-card transition-transform duration-hover ease-snap active:scale-[0.97] active:duration-press">
            <Card tone={tone}>{body}</Card>
        </Link>
    ) : (
        <Card tone={tone}>{body}</Card>
    );
};
